export const VNPPI_SET_CONFIGURATIONS = 'VNPPI_SET_CONFIGURATIONS'
export const VNPPI_SET_ORDER_PAYMENTS = 'VNPPI_SET_ORDER_PAYMENTS'
export const VNPPI_ADD_SCANNED_TENDER_TO_ORDER = 'VNPPI_ADD_SCANNED_TENDER_TO_ORDER'
export const VNPPI_SET_PRE_ORDER_PAYMENTS = 'VNPPI_SET_PRE_ORDER_PAYMENTS'
export const VNPPI_CONFIGURATION_ERROR = 'VNPPI_CONFIGURATION_ERROR'
